import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import {getResourceLinkComponentByType} from '../../../helpers/componentHelper';
import _ from 'lodash';

class Text extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            resources: this.props.resources,
            resourceLinks: [],
            userData: this.props.userData,
            initialised: false,
            checkResourcesComplete: false,
        };


        this.setResourceLinks = this.setResourceLinks.bind(this);
        this.onCheckResourcesComplete = this.onCheckResourcesComplete.bind(this);
        this.onResourceLinkComplete = this.onResourceLinkComplete.bind(this);
    }

    componentDidMount() {
        this.setResourceLinks();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                checkResourcesComplete: true
            });
        }

    }

    componentDidUpdate(){
        if(this.state.checkResourcesComplete){
            this.onCheckResourcesComplete();
        }

    }

    setResourceLinks(){

        let resourceLinks = [];
        _.forEach(this.state.resources, function (resource) {
            let resourceLink = Object.assign({}, getResourceLinkComponentByType(resource.object_type),{
                data: resource,
                isComplete: !resource.required
            });
            resourceLinks = dataHelper.immutablePush(resourceLinks, resourceLink);
        });

        this.setState({
            resourceLinks: Object.assign([],resourceLinks),
            checkResourcesComplete: true,
            initialised: true
        });
    }



    onCheckResourcesComplete(){
        let completeResourceCount = 0;
        let userData = this.state.userData;
        this.setState({checkResourcesComplete: false});
        _.forEach(this.state.resourceLinks, function (resource) {
            if(appHelper.isDefined(resource.data.asset_id)){
                let objectUserData = userDataHelper.getAttachmentObjectUserData(userData, resource.data.asset_id);
                if(objectUserData.status === objectConstants.STATUS_COMPLETE || !resource.data.required) {
                    completeResourceCount++;
                }
            }else{
                let screenUserData = userDataHelper.getResourceScreenUserData(userData, resource.data.screen_id);
                if (screenUserData.status === objectConstants.STATUS_COMPLETE || !resource.data.required) {
                  completeResourceCount++;
               }
            }
        });

        if(completeResourceCount >= this.state.resourceLinks.length){
            //console.log(`onCheckResourcesComplete: ${completeResourceCount} complete`);
            this.props.onResourcesComplete(this.state.resourceLinks);
        }
    }

    onResourceLinkComplete(resourceLink){
        let updatedResource = {};
        let updatedResourceIndex = {};

        for(let i = 0; i < this.state.resourceLinks.length; i++){
            let resource = this.state.resourceLinks[i];
            if(appHelper.isDefined(resourceLink.asset_id)){
                if(resource.data.asset_id === resourceLink.asset_id){
                    updatedResource = Object.assign({},resource,{
                        isComplete: true
                    });
                    updatedResourceIndex = i;
                    break;
                }
            }else{
                if(resource.data.screen_id === resourceLink.screen_id && !appHelper.isDefined(resource.data.asset_id)){
                    updatedResource = Object.assign({},resource,{
                        isComplete: true
                    });
                    updatedResourceIndex = i;
                    break;
                }
            }
        }

        this.setState({
            resourceLinks: dataHelper.immutableSplice(this.state.resourceLinks,updatedResourceIndex, 1, updatedResource),
            checkResourcesComplete: true
        });
    }

    render() {
        return (
            <div>
                {
                    this.state.initialised
                    ?
                        <ul className="resource-links">
                            {this.state.resourceLinks.map(resourceLink =>
                            <resourceLink.component key={appHelper.isDefined(resourceLink.data.asset_id) ? resourceLink.data.asset_id : resourceLink.data.screen_id} resource={resourceLink.data}/>
                            )}
                        </ul>
                    :
                        null
                }
            </div>
        );
    }
}

Text.propTypes = {
    resources: PropTypes.array.isRequired,
    onResourcesComplete: PropTypes.func,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

Text.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Text);



/** WEBPACK FOOTER **
 ** ./src/components/objects/resourceLinks/ResourceLinks.js
 **/